export enum TransactionStatus {
  AwaitingPaymentMethod = 'awaiting_payment_method',
  Processing = 'processing',
  AwaitingCapture = 'awaiting_capture',
  Succeeded = 'completed',
  Cancelled = 'declined',
  Reversed = 'reversed',
  PreAuthSuccess = 'pre_auth_success',
  PreAuthFailed = 'pre_auth_failed',
}
